import React, { useState } from "react";
import { useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import { useImageTypeOverlay } from "../../hooks";
import AppModal from "../AppModal";
import TakePhoto from "./components/TakePhoto";
import SavePhoto from "./components/SavePhoto";

import { useImageTypes } from "../../hooks";
import useSelectImageType from "./useSelectImageType";

type Props = {
    assetTypeIds: Array<number>,
    exclusionReasonTypeId: number,
    isVisible: boolean,
    photos: Array<any>,
    onClose: Function,
    onSuccess: Function,
};

const defaultPhoto = {
    imageUrl: "",
    thumbnailUrl: "",
    width: 0,
    height: 0,
};

/**
 * Camera Component
 */
export default ({
    assetTypeId,
    exclusionReasonTypeId,
    isVisible,
    disableImageType = false,
    photos,
    onClose,
    onSuccess,
    onError,
}: Props) => {
    const { geoLocation } = useSelector((state) => state);
    const [photo, setPhoto] = useState(defaultPhoto);

    const imageTypes = useImageTypes([assetTypeId], exclusionReasonTypeId);

    const selectedImageType = useSelectImageType(
        exclusionReasonTypeId,
        photos[0],
        imageTypes
    );

    const overlay = useImageTypeOverlay((selectedImageType || {}).id);

    const onSavePhotoSuccess = async (imageType) => {
        onSuccess &&
            onSuccess({
                id: uuid(),
                imageType: imageType,
                createdDate: new Date().toISOString(),
                image: photo.imageUrl,
                thumbnail: photo.thumbnailUrl,
                latitude: geoLocation.coords.latitude,
                longitude: geoLocation.coords.longitude,
                uploaded: false,
            });

        setPhoto(defaultPhoto);
    };

    const onPhotoClear = () => setPhoto(defaultPhoto);

    const title = photo.imageUrl ? "Saving image" : "Capturing image";

    if (!isVisible) return null;

    return (
        <AppModal
            fullScreen={true}
            isVisible={isVisible}
            onClose={onClose}
            title={title}
        >
            {photo.imageUrl ? (
                <SavePhoto
                    disableImageType={disableImageType}
                    assetTypeId={assetTypeId}
                    onRetakePhoto={onPhotoClear}
                    onSuccess={onSavePhotoSuccess}
                    photosCount={photos.length}
                    exclusionReasonTypeId={exclusionReasonTypeId}
                    photo={photo}
                />
            ) : (
                <TakePhoto
                    onSuccess={setPhoto}
                    onError={onError}
                    overlay={overlay}
                />
            )}
        </AppModal>
    );
};
